import { render, staticRenderFns } from "./partnerList.vue?vue&type=template&id=3679172e&scoped=true&"
import script from "./partnerList.vue?vue&type=script&lang=js&"
export * from "./partnerList.vue?vue&type=script&lang=js&"
import style0 from "./partnerList.vue?vue&type=style&index=0&id=3679172e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3679172e",
  null
  
)

export default component.exports